module.exports = __webpack_public_path__ + "img/bdb946b.jpg";